import React, { useState } from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { PeopleAlt } from "@mui/icons-material";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

const RenderBadges = ({
  data,
  axiosPrivate,
  setSimSoundData,
  setSimSoundModalOpen,
  handleOpenModalUpp,
  showBUpp = true,
  showSimSound = true,
}) => {
  const axiosPrivateHook = useAxiosPrivate();
  const axiosClient = axiosPrivate || axiosPrivateHook;
  const [dyzTooltip, setDyzTooltip] = useState({ status: "idle", pinyin: "", meaning: "" });

  const handleDyzOpen = async () => {
    if (!data?.hanzi_id || !data?.hanzi_character) return;
    if (dyzTooltip.status === "loaded" || dyzTooltip.status === "loading") return;
    setDyzTooltip((prev) => ({ ...prev, status: "loading" }));
    try {
      const response = await axiosClient.get(
        `/renderBadgeDyz?hanziId=${data.hanzi_id}&hanziChar=${encodeURIComponent(data.hanzi_character)}`
      );
      const dyzRow = Array.isArray(response?.data) ? response.data[0] : response?.data;
      console.log("Pinyin:", dyzRow?.hanzi_pinyin, "Meaning:", dyzRow?.hanzi_meaning);
      setDyzTooltip({
        status: "loaded",
        pinyin: dyzRow?.hanzi_pinyin || "",
        meaning: dyzRow?.hanzi_meaning || "",
      });
    } catch (error) {
      if (error.name === "CanceledError") {
        return;
      }
      setDyzTooltip({ status: "error", pinyin: "", meaning: "" });
    }
  };
  
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        maxHeight: "20px",
        fontSize: "0.75rem",
        mt: 1,
        mb: 0.25,
        gap: 0.5,
        px: { xs: 0.5, md: 1 },
        flexGrow: 1,
      }}
    >
      <Box
        sx={{
          backgroundColor: "orange",
          color: "white",
          fontWeight: "bold",
          fontSize: "0.75rem",
          px: 0.5,
          py: 0,
          ml: 0,
          borderRadius: "4px",
          display: "inline-block",
          textAlign: "center",
          whiteSpace: "nowrap",
          // border: data.hanzi_hsk_comp < 9 ? "2px solid hsl(322,34%,61%)" : "orange",
        }}
      >
        {data.hanzi_hsk_level === 9 ? "- /" : `${data.hanzi_hsk_level} /`}{" "}
        {data.hanzi_hsk_comp === 9 ? "-" : data.hanzi_hsk_comp}
      </Box>
      {data.hanzi_type < 3 && (
        <Box
          sx={{
            backgroundColor: "hsl(322,34%,61%)",
            color: "white",
            fontWeight: "bold",
            fontSize: "0.75rem",
            px: 0.5,
            py: 0,
            borderRadius: "4px",
            display: "inline-block",
            textAlign: "center",
          }}
        >
          {data.hanzi_freq < 9998 ? data.hanzi_freq : "-"}
        </Box>
      )}
      {data.hanzi_dyz > 0 && (
        <Tooltip
          title={
            dyzTooltip.status === "loading"
              ? "Loading..."
              : dyzTooltip.status === "loaded"
              ? `${dyzTooltip.pinyin || "-"} • ${dyzTooltip.meaning || "-"}`
              : dyzTooltip.status === "error"
              ? "Unavailable"
              : "Tap for details"
          }
          onOpen={handleDyzOpen}
        >
          <Box
            sx={{
              backgroundColor: "hsl(118,28%,79%)",
              color: "hsl(39,100%,32%)",
              fontWeight: "bold",
              fontSize: "0.75rem",
              px: 0.5,
              py: 0,
              borderRadius: "4px",
              display: "inline-block",
              textAlign: "center",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "hsl(118,28%,65%)",
              },
            }}
          >
            dyz
          </Box>
        </Tooltip>
      )}
      {data.hanzi_measure && data.hanzi_measure.length > 0 && (
        <Tooltip title={data.hanzi_measure}>
          <Box
            sx={{
              backgroundColor: "hsl(118,28%,79%)",
              color: "hsl(39,100%,32%)",
              fontWeight: "bold",
              fontSize: "0.75rem",
              px: 0.5,
              py: 0,
              borderRadius: "4px",
              display: "inline-block",
              textAlign: "center",
            }}
          >
            Mea
          </Box>
        </Tooltip>
      )}
      {/* <Box
        sx={{
          backgroundColor: "orange",
          color: "white",
          fontWeight: "bold",
          fontSize: "0.75rem",
          px: 0.5,
          py: 0,
          borderRadius: "4px",
          display: "inline-block",
          textAlign: "center",
        }}
      >
        {data.hanzi_duo_section === 9
          ? "-"
          : `${data.hanzi_duo_section}:${
              parseFloat(data.hanzi_duo_unit) % 1 === 0 ? Math.floor(data.hanzi_duo_unit) : data.hanzi_duo_unit
            }`}
      </Box> */}
      <Box
        sx={{
          backgroundColor: "orange",
          color: "white",
          fontWeight: "bold",
          fontSize: "0.75rem",
          px: 0.5,
          py: 0,
          borderRadius: "4px",
          display: "inline-block",
          textAlign: "center",
        }}
      >
        {data.hanzi_ci_course === 9
          ? "-"
          : `${data.hanzi_ci_course}:${data.hanzi_ci_lesson}`}{" "}
      </Box>
      <Box
        sx={{
          backgroundColor: "orange",
          color: "white",
          fontWeight: "bold",
          fontSize: "0.75rem",
          px: 0.5,
          py: 0,
          borderRadius: "4px",
          display: "inline-block",
          textAlign: "center",
        }}
      >
        {data.hanzi_dom_course === 9
          ? "-"
          : `${data.hanzi_dom_course}:${data.hanzi_dom_chapter}:${data.hanzi_dom_lesson}`}{" "}
      </Box>
      {data.hanzi_proper > 0 && (
        <Tooltip
          title={
            data.hanzi_proper === 1
              ? "A common surname"
              : data.hanzi_proper === 2
              ? "A common male given name"
              : data.hanzi_proper === 3
              ? "A common female given name"
              : data.hanzi_proper === 4
              ? "A common unisex given name"
              : data.hanzi_proper === 5
              ? "Commonly used as both a surname and a given name"
              : ""
          }
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "2px" }}>
            <PeopleAlt sx={{ fontSize: "16px", color: "orange" }} />
            <Typography
              variant="body2"
              sx={{
                fontSize: "10px",
                color: "darkText",
                verticalAlign: "super",
                lineHeight: 1,
                ml: -0.5,
                mb: 1,
              }}
            >
              {data.hanzi_proper}
            </Typography>
          </Box>
        </Tooltip>
      )}
      {data.hanzi_speech_part3 && data.hanzi_speech_part3 !== "" && showSimSound && (
        <Box
          onClick={async (e) => {
            e.stopPropagation();
            try {
              const simSoundResponse = await axiosPrivate.get(`/questSimSound?simSound=${data.hanzi_speech_part3}`);
              setSimSoundData(simSoundResponse.data);
              setSimSoundModalOpen(true);
            } catch (error) {
              console.error("Error fetching similar sound data:", error);
            }
          }}
          sx={{
            backgroundColor: "hsl(118,28%,79%)",
            color: "hsl(39,100%,32%)",
            fontWeight: "bold",
            fontSize: "0.75rem",
            px: 0.5,
            py: 0,
            borderRadius: "4px",
            display: "inline-block",
            textAlign: "center",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "hsl(118,28%,65%)",
            },
          }}
        >
          {data.hanzi_speech_part3}
        </Box>
      )}
      {data.hanzi_speech > 0 && data.hanzi_type === 4 && (
        <Box
          sx={{
            backgroundColor: "hsl(322,34%,61%)",
            color: "white",
            fontWeight: "bold",
            fontSize: "0.75rem",
            px: 0.5,
            py: 0,
            borderRadius: "4px",
            display: "inline-block",
            textAlign: "center",
          }}
        >
          P{data.hanzi_speech}
        </Box>
      )}
      {showBUpp && (
        <Box
          sx={{
            backgroundColor: "hsl(322,34%,61%)",
            color: "white",
            fontWeight: "bold",
            fontSize: "0.75rem",
            px: 0.5,
            py: 0,
            borderRadius: "4px",
            display: "inline-block",
            textAlign: "center",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "hsl(322,34%,51%)",
            },
          }}
          onClick={() =>
            handleOpenModalUpp?.(
              data.hanzi_id,
              data.hanzi_type,
              data.hanzi_character,
              data.hanzi_pinyin,
              data.hanzi_ptext,
              data.hanzi_measure,
              data.hanzi_dyz,
              data.hanzi_hsk_level,
              data.hanzi_hsk_comp,
              data.hanzi_freq,
              data.hanzi_speech,
              data.hanzi_proper,
              data.hanzi_duo_section,
              data.hanzi_duo_unit,
              data.hanzi_dom_chapter,
              data.hanzi_dom_course,
              data.hanzi_dom_lesson,
              data.hanzi_speech_part3
            )
          }
        >
          BUP
        </Box>
      )}
      {data.hanzi_meaning_hint && data.hanzi_meaning_hint.length > 0 && (
        <Tooltip title={data.hanzi_meaning_hint}>
          <Box
            sx={{
              backgroundColor: "hsl(118,28%,79%)",
              color: "hsl(39,100%,32%)",
              fontWeight: "bold",
              fontSize: "0.75rem",
              px: 0.5,
              py: 0,
              borderRadius: "4px",
              display: "inline-block",
              textAlign: "center",
              cursor: "pointer",
            }}
          >
            mH
          </Box>
        </Tooltip>
      )}
      {data.hanzi_meaning_not && data.hanzi_meaning_not.length > 0 && (
        <Tooltip title={data.hanzi_meaning_not}>
          <Box
            sx={{
              backgroundColor: "hsl(118,28%,79%)",
              color: "hsl(39,100%,32%)",
              fontWeight: "bold",
              fontSize: "0.75rem",
              px: 0.5,
              py: 0,
              borderRadius: "4px",
              display: "inline-block",
              textAlign: "center",
              cursor: "pointer",
            }}
          >
            mN
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};

export default RenderBadges;
